import { Component, Input } from '@angular/core';
import { GameService } from '../../../../../shared/services/game.service';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import { Player } from '../../../../../shared/interfaces/player.interface';
import { Vote } from '../../../../../shared/interfaces/vote.interface';
 
@Component({
  selector: 'app-player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.scss']
})

export class PlayerComponent {
  @Input() player: Player;
  @Input() vote: Vote;

  private get getInitials() { return this.player.Initials.toUpperCase().substr(0, 2) }

  faCoffee = faCoffee;
  showImage: boolean = false;

  constructor(private gameService: GameService) { }

  getState() {
    return this.gameService.gameState;
  }
}
